<script lang="ts">
  import { onMount } from 'svelte';
  import Router from 'svelte-spa-router';
  import { wrap } from 'svelte-spa-router/wrap';
  import Login from './routes/Login.svelte';
  import InvitationAccept from './routes/InvitationAccept.svelte';
  import PasswordResetAccept from './routes/PasswordResetAccept.svelte';
  import Overview from './routes/Overview.svelte';
  import Persons from './routes/Persons.svelte';
  import PersonDetail from './routes/PersonDetail.svelte';
  import Payments from './routes/Payments.svelte';
  import PaymentDetail from './routes/PaymentDetail.svelte';
  import Funnels from './routes/Funnels.svelte';
  import FunnelDetail from './routes/FunnelDetail.svelte';
  import FunnelPipelinePage from './routes/FunnelPipelinePage.svelte';
  import Cohorts from './routes/Cohorts.svelte';
  import CustomTable from './routes/CustomTable.svelte';
  import CustomRecordDetail from './routes/CustomRecordDetail.svelte';
  import Automations from './routes/Automations.svelte';
  import AutomationEditor from './routes/AutomationEditor.svelte';
  import SettingsIndex from './routes/settings/Index.svelte';
  import SettingsFunnels from './routes/settings/Funnels.svelte';
  import SettingsProducts from './routes/settings/Products.svelte';
  import SettingsDataStructure from './routes/settings/DataStructure.svelte';
  import SettingsUsers from './routes/settings/Users.svelte';
  import SettingsWebhooks from './routes/settings/Webhooks.svelte';
  import Audit from './routes/settings/Audit.svelte';
  import NotFound from './routes/NotFound.svelte';
  import AlertModal from './components/AlertModal.svelte';
  import { fetchMe } from './lib/api';

  let booted = $state(false);

  onMount(async () => {
    await fetchMe();
    booted = true;
  });

  const authGate = {
    conditions: [
      async () => {
        await fetchMe();
        return true;
      },
    ],
  };

  const routes = {
    '/login': Login,
    '/invitations/accept': InvitationAccept,
    '/auth/password-reset': PasswordResetAccept,
    '/': wrap({ component: Overview, ...authGate }),
    '/persons': wrap({ component: Persons, ...authGate }),
    '/persons/:id': wrap({ component: PersonDetail, ...authGate }),
    '/payments': wrap({ component: Payments, ...authGate }),
    '/payments/:id': wrap({ component: PaymentDetail, ...authGate }),
    '/funnels': wrap({ component: Funnels, ...authGate }),
    '/funnels/:slug/pipeline': wrap({ component: FunnelPipelinePage, ...authGate }),
    '/funnels/:slug': wrap({ component: FunnelDetail, ...authGate }),
    '/cohorts': wrap({ component: Cohorts, ...authGate }),
    '/tables/:slug': wrap({ component: CustomTable, ...authGate }),
    '/tables/:slug/:id': wrap({ component: CustomRecordDetail, ...authGate }),
    '/automations': wrap({ component: Automations, ...authGate }),
    '/automations/:id': wrap({ component: AutomationEditor, ...authGate }),
    '/settings': wrap({ component: SettingsIndex, ...authGate }),
    '/settings/funnels': wrap({ component: SettingsFunnels, ...authGate }),
    '/settings/products': wrap({ component: SettingsProducts, ...authGate }),
    '/settings/data-structure': wrap({ component: SettingsDataStructure, ...authGate, props: { sub: 'tables' } }),
    '/settings/data-structure/tables/:slug': wrap({ component: SettingsDataStructure, ...authGate, props: { sub: 'tables' } }),
    '/settings/data-structure/duplicates': wrap({ component: SettingsDataStructure, ...authGate, props: { sub: 'duplicates' } }),
    '/settings/data-structure/import': wrap({ component: SettingsDataStructure, ...authGate, props: { sub: 'import' } }),
    '/settings/data-structure/import/:slug': wrap({ component: SettingsDataStructure, ...authGate, props: { sub: 'import' } }),
    '/settings/users': wrap({ component: SettingsUsers, ...authGate }),
    '/settings/webhooks': wrap({ component: SettingsWebhooks, ...authGate }),
    '/audit': wrap({ component: Audit, ...authGate }),
    '*': NotFound,
  };
</script>

{#if booted}
  <Router {routes} />
{:else}
  <div class="min-h-screen grid place-items-center text-sm text-[var(--color-text-muted)]">
    Завантаження…
  </div>
{/if}

<!-- Глобальні alert-модалки (замість window.alert) -->
<AlertModal />
